import React, { useState } from 'react';
import { TouchableOpacity } from 'react-native';
import { useSelector } from 'react-redux';
import { QuoteCardProps } from './QuoteCard.types';
import QuoteCardHeader from './QuoteCardHeader';
import CardDetails from './QuoteCardDetails';
import { styles } from './QuoteCard.styles';
import { trackGTMEvent } from 'src/helpers/gtm/gtmEvents';
import { RootState } from 'src/store/store';

const QuoteCard: React.FC<QuoteCardProps> = ({
  id,
  price,
  coverage,
  details,
  isSelected,
  onSelect,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const accountType = useSelector((state: RootState) => state.UI.accountType);

  const handleSelectCard = () => onSelect(id);

  const handleToggleExpand = () => {
    trackGTMEvent('quote-card-detail-toggle-pressed', {}, accountType);
    setIsExpanded(!isExpanded);
  };

  return (
    <TouchableOpacity style={styles.cardContainer} onPress={handleSelectCard}>
      <QuoteCardHeader
        price={price}
        coverage={coverage}
        logo={details.logo}
        isSelected={isSelected}
        isExpanded={isExpanded}
        onToggleExpand={handleToggleExpand}
      />
      {isExpanded && <CardDetails details={details} isSelected={isSelected} />}
    </TouchableOpacity>
  );
};

export default QuoteCard;
